import { z } from 'zod'

export const deviceCreateSchema = z.object({
    name: z.string().min(1, 'Povinné pole').max(128, 'Maximálně 128 znaků'),
    username: z.string().min(1, 'Povinné pole').max(32, 'Maximálně 32 znaků'),
    password: z.string().min(1, 'Povinné pole').max(32, 'Maximálně 32 znaků')
})

export const deviceUpdateSchema = z.object({
    name: z.string().min(1, 'Povinné pole').max(128, 'Maximálně 128 znaků'),
    username: z.string().min(1, 'Povinné pole').max(32, 'Maximálně 32 znaků'),
    password: z.string().max(32, 'Maximálně 32 znaků')
})

export type DeviceCreateValues = z.infer<typeof deviceCreateSchema>
export type DeviceUpdateValues = z.infer<typeof deviceUpdateSchema>
